import axios from 'axios';
export async function postApiCall(baseURLs, data) {
  if (baseURLs) {
    try {
      let res = await axios({
        method: 'POST',
        baseURL: baseURLs?.API_DIY_URL,
        url: '/v1/section/form',
        headers: {
          'website-url': 'https://' + location.host + location.pathname
        },
        data
      });
      if (res) {
        return res.data;
      }
    } catch (err) {
      return;
    }
  }
}

export async function postApiCallForm(baseURLs, data, extraProps) {
  if (baseURLs) {
    try {
      let res = await axios({
        method: 'POST',
        baseURL: baseURLs?.API_DIY_URL,
        url: '/v1/diy/landingPages/form',
        headers: {
          'website-url': 'https://' + location.host + location.pathname
        },
        data
      }).then((res) => {
        if (extraProps && extraProps.formSubmitSuccess) {
          extraProps.formSubmitSuccess();
        }
        return res.data;
      });
    } catch (err) {
      return;
    }
  }
}
